import type { Account } from '@shared/products-types';

import type { MenuItemCondition, MenuItemDefinition, MenuItemStrategy } from './typing';

type MenuItemStrategyArguments<Product, MenuItemId extends string> = {
    menuItem: MenuItemDefinition<Product, MenuItemId>;
    featureCondition?: () => boolean;
    productCondition?: MenuItemCondition<Product>;
};

export const createMenuItemStrategy =
    <Product = Account, MenuItemId extends string = string>({
        menuItem,
        featureCondition,
        productCondition,
    }: MenuItemStrategyArguments<Product, MenuItemId>): MenuItemStrategy<Product, MenuItemId> =>
    (product) => {
        if (featureCondition && !featureCondition()) {
            return null;
        }

        const renderMenuItem = !productCondition || productCondition(product);

        if (renderMenuItem) {
            return menuItem(product);
        }

        return null;
    };
